import { render, staticRenderFns } from "./Afiliaciones.vue?vue&type=template&id=40856c50&scoped=true"
import script from "./Afiliaciones.vue?vue&type=script&lang=js"
export * from "./Afiliaciones.vue?vue&type=script&lang=js"
import style0 from "./Afiliaciones.vue?vue&type=style&index=0&id=40856c50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40856c50",
  null
  
)

export default component.exports